// extracted by mini-css-extract-plugin
export default {"wrapper":"Advertising_wrapper__QMOWr"};